import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/

export const constantRouterMap = [
    { path: '/vx_login', component: () => import('@/views/login/vx_login'), hidden: true },
    { path: '/scanner', component: () => import('@/views/wms/scanner'), hidden: true },
    {
        path: '/login',
        meta: { title: '登录', icon: 'total-week' },
        component: () => import('@/views/login/index'),
        hidden: true
    },
    { path: '/404', component: () => import('@/views/404'), hidden: true },
    {
        path: '',
        component: Layout,
        redirect: '/home',
        children: [{
            path: 'home',
            name: 'home',
            component: () => import('@/views/home/index'),
            meta: { title: '首页', icon: 'home' }
        }]
    }
]

export const asyncRouterMap = [
    {
        path: '/account',
        component: Layout,
        name: 'account',
        redirect: 'account',
        meta: { title: '财务管理', icon: 'total-week' },
        children: [{
            path: '/account/addAccount',
            name: 'addAccount',
            component: () => import('@/views/account/add'),
            meta: { title: '新增打款', icon: 'total_add' }
        }, {
            path: '/account/listAccount',
            name: 'listAccount',
            component: () => import('@/views/account/index'),
            meta: { title: '提成结算', icon: 'total-yesterday' }
        }, {
            path: '/account/listIncome',
            name: 'listIncome',
            component: () => import('@/views/account/list'),
            meta: { title: '打款记录', icon: 'total_list' }
        }, {
            path: '/account/invoiceList',
            name: 'invoiceList',
            component: () => import('@/views/account/invoiceList'),
            meta: { title: '发票记录', icon: 'total_invoice' }
        }]
    },
    {
        path: '/crm',
        component: Layout,
        name: 'crm',
        redirect: '/crm/customer',
        meta: { title: '首营管理', icon: 'crm_admin' },
        children: [{
            path: '/crm/customer',
            name: 'customer',
            component: () => import('@/views/crm/customer/index'),
            meta: { title: '客户管理', icon: 'ums-resource' }
        },
        {
            path: '/crm/business_management',
            name: 'business_management',
            component: () => import('@/views/crm/business_management/index'),
            meta: { title: '资质管理', icon: 'crm_license' }
        },
        {
            path: '/crm/license_add',
            name: 'license_add',
            component: () => import('@/views/license/license_add'),
            meta: { title: '申请授权', icon: 'crm_license_add' },
        },
        {
            path: '/crm/license_admin',
            name: 'license_admin',
            component: () => import('@/views/license/license_admin'),
            meta: { title: '授权管理', icon: 'crm_license_admin', keepAlive: true },
        },
        ]
    },
    {
        path: '/wms',
        component: Layout,
        name: 'wms',
        redirect: '/wms',
        meta: { title: '仓库管理', icon: 'wms' },
        children: [{
            path: '/wms/inbound',
            name: 'inbound',
            component: () => import('@/views/wms/inbound/index'),
            meta: { title: '入库记录', icon: 'wms_add' }
        },
        {
            path: '/wms/outbound',
            name: 'outbound',
            component: () => import('@/views/wms/outbound/index'),
            meta: { title: '出库记录', icon: 'wms_out' }
        },
        {
            path: '/wms/check',
            name: 'wmsCheck',
            component: () => import('@/views/wms/scanner/index.vue'),
            meta: { title: '盘库记录', icon: 'wms_out' }
        },
        {
            path: '/wms/depot',
            name: 'depot',
            component: () => import('@/views/wms/depot/index'),
            meta: { title: '库存管理', icon: 'wms_detail' }
        },
        ]
    },
    {
        path: '/pms',
        component: Layout,
        redirect: '/pms/product',
        name: 'pms',
        meta: { title: '产品管理', icon: 'product' },
        children: [{
            path: '/pms/product',
            name: 'product',
            component: () => import('@/views/pms/product/index'),
            meta: { title: '产品列表', icon: 'product-list' }
        },
        {
            path: '/pms/addProduct',
            name: 'addProduct',
            component: () => import('@/views/pms/product/add'),
            meta: { title: '添加产品', icon: 'product-add' }
        },
        {
            path: '/pms/updateProduct',
            name: 'updateProduct',
            component: () => import('@/views/pms/product/update'),
            meta: { title: '修改产品', icon: 'product-add' },
            hidden: true
        },
        {
            path: '/pms/productCate',
            name: 'productCate',
            component: () => import('@/views/pms/productCate/index'),
            meta: { title: '产品分类', icon: 'product-cate' }
        },
        {
            path: '/pms/addProductCate',
            name: 'addProductCate',
            component: () => import('@/views/pms/productCate/add'),
            meta: { title: '添加产品分类' },
            hidden: true
        },
        {
            path: '/pms/updateProductCate',
            name: 'updateProductCate',
            component: () => import('@/views/pms/productCate/update'),
            meta: { title: '修改产品分类' },
            hidden: true
        },
        {
            path: '/pms/productAttr',
            name: 'productAttr',
            component: () => import('@/views/pms/productAttr/index'),
            meta: { title: '产品类型', icon: 'product-attr' }
        },
        {
            path: '/pms/productAttrList',
            name: 'productAttrList',
            component: () => import('@/views/pms/productAttr/productAttrList'),
            meta: { title: '产品属性列表' },
            hidden: true
        },
        {
            path: '/pms/addProductAttr',
            name: 'addProductAttr',
            component: () => import('@/views/pms/productAttr/addProductAttr'),
            meta: { title: '添加产品属性' },
            hidden: true
        },
        {
            path: '/pms/updateProductAttr',
            name: 'updateProductAttr',
            component: () => import('@/views/pms/productAttr/updateProductAttr'),
            meta: { title: '修改产品属性' },
            hidden: true
        },
        {
            path: '/pms/brand',
            name: 'brand',
            component: () => import('@/views/pms/brand/index'),
            meta: { title: '品牌管理', icon: 'product-brand' }
        },
        {
            path: '/pms/addBrand',
            name: 'addBrand',
            component: () => import('@/views/pms/brand/add'),
            meta: { title: '添加品牌' },
            hidden: true
        },
        {
            path: '/pms/updateBrand',
            name: 'updateBrand',
            component: () => import('@/views/pms/brand/update'),
            meta: { title: '编辑品牌' },
            hidden: true
        }
        ]
    },
    {
        path: '/oms',
        component: Layout,
        redirect: '/oms/order',
        name: 'oms',
        meta: { title: '销售管理', icon: 'order' },
        children: [
            {
                path: '/oms/order',
                name: 'order',
                component: () => import('@/views/oms/order/index'),
                meta: { title: '销售记录', icon: 'product-list', keepAlive: true }
            },
            {
                path: '/oms/returnOrder',
                name: 'order',
                component: () => import('@/views/oms/return_order/index'),
                meta: { title: '退货记录', icon: 'product-list', keepAlive: true }
            },
            {
                path: '/oms/orderDetail',
                name: 'orderDetail',
                component: () => import('@/views/oms/order_detail/index'),
                meta: { title: '订单详情' },
                hidden: true
            },
            {
                path: '/oms/addOms',
                name: 'addOms',
                component: () => import('@/views/oms/add_order/index'),
                meta: { title: '新增订单', icon: 'order-setting' }
            },
            {
                path: '/oms/addOmsV2',
                name: 'addOmsV2',
                component: () => import('@/views/oms/add_order_v2/index'),
                meta: {title: '新增订单V2', icon: 'order-setting'},
                hidden: true
            },
        ]
    },
    {
        path: '/ums',
        component: Layout,
        redirect: '/ums/admin',
        name: 'ums',
        meta: { title: '系统管理', icon: 'ums' },
        children: [
            {
                path: '/ums/admin',
                name: 'admin',
                component: () => import('@/views/ums/admin/index'),
                meta: { title: '用户列表', icon: 'ums-admin' }
            },
            {
                name: 'cron',
                path: '/ums/cron',
                component: () => import('@/views/cron/index'),
                meta: { title: '定时任务', icon: 'total-week' }
            },
            {
                path: '/ums/role',
                name: 'role',
                component: () => import('@/views/ums/role/index'),
                meta: { title: '角色列表', icon: 'ums-role' }
            },
            {
                path: '/ums/allocMenu',
                name: 'allocMenu',
                component: () => import('@/views/ums/role/allocMenu'),
                meta: { title: '分配菜单' },
                hidden: true
            },
            {
                path: '/ums/allocResource',
                name: 'allocResource',
                component: () => import('@/views/ums/role/allocResource'),
                meta: { title: '分配资源' },
                hidden: true
            },
            {
                path: '/ums/menu',
                name: 'menu',
                component: () => import('@/views/ums/menu/index'),
                meta: { title: '菜单列表', icon: 'ums-menu' }
            },
            {
                path: '/ums/addMenu',
                name: 'addMenu',
                component: () => import('@/views/ums/menu/add'),
                meta: { title: '添加菜单' },
                hidden: true
            },
            {
                path: '/ums/updateMenu',
                name: 'updateMenu',
                component: () => import('@/views/ums/menu/update'),
                meta: { title: '修改菜单' },
                hidden: true
            },

        ]
    },
    {
        path: '/cms',
        component: Layout,
        redirect: '/site/admin',
        name: 'cms',
        meta: { title: '内容管理', icon: 'content_admin' },
        children: [
            {
                path: '/cms/news',
                name: 'news',
                component: () => import('@/views/site/news/index'),
                meta: { title: '公司动态', icon: 'content_news' },
            }
        ]
    },
    { path: '*', redirect: '/404', hidden: true },
]

export default new Router({
    mode: 'history', //后端支持可开
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
})

